"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidContractEndDate = isValidContractEndDate;
const MONTHS_PER_PERIOD = {
    MONTHLY: 1,
    QUARTERLY: 3,
    SEMI_ANNUAL: 6,
    YEARLY: 12,
};
const TOLERANCE_MS = 12 * 60 * 60 * 1000;
const MAX_STEPS = 240;
function isValidContractEndDate(endDate, startDate, billingInterval) {
    if (!(endDate instanceof Date) || isNaN(endDate.getTime()))
        return false;
    if (!(startDate instanceof Date) || isNaN(startDate.getTime()))
        return false;
    if (endDate.getTime() <= startDate.getTime())
        return false;
    const stepMonths = MONTHS_PER_PERIOD[billingInterval];
    for (let n = 1; n <= MAX_STEPS; n++) {
        const stepped = addMonthsClamped(startDate, stepMonths * n);
        if (Math.abs(endDate.getTime() - stepped.getTime()) < TOLERANCE_MS)
            return true;
        if (stepped.getTime() > endDate.getTime() + TOLERANCE_MS)
            return false;
    }
    return false;
}
/**
 * Adds `months` to `date`, clamping the day-of-month to the last day of the target month when
 * the original day-of-month doesn't exist there (matches Stripe's billing-cycle convention).
 * Example: Jan 31 + 1 month → Feb 28 (non-leap) or Feb 29 (leap).
 */
function addMonthsClamped(date, months) {
    const year = date.getUTCFullYear();
    const month = date.getUTCMonth();
    const day = date.getUTCDate();
    const total = month + months;
    const targetYear = year + Math.floor(total / 12);
    const targetMonth = ((total % 12) + 12) % 12;
    const lastDayOfTarget = new Date(Date.UTC(targetYear, targetMonth + 1, 0)).getUTCDate();
    const clampedDay = Math.min(day, lastDayOfTarget);
    return new Date(Date.UTC(targetYear, targetMonth, clampedDay, date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds()));
}
